import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-checkbox-multiple',
    templateUrl: './question-checkbox-multiple.component.html',
    styleUrls: ['./question-checkbox-multiple.component.scss'],
    standalone: false
})
export class QuestionCheckboxMultipleComponent implements OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Output() questionAnswer = new EventEmitter();

  items: any[] = [];
  uniqueControlName = `checkbox-name-${newGuid()}`;
  selectedItems: any[] = [];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.items = [];
      if (this.question?.options) {
        this.items = parseOptions(this.question?.options);
      }
      if (this.question?.answer) {
        this.selectedItems = this.question?.answer?.split('|');
      } else {
        this.selectedItems = [];
      }
    }
  }

  private isNoneOfAbove(value: string): boolean {
    return (value || '').trim().toLowerCase().startsWith('none');
  }

  isOptionDisabled(value: string): boolean {
    if (this.readOnly) {
      return true;
    }

    return this.selectedItems.some((x) => this.isNoneOfAbove(x)) && !this.isNoneOfAbove(value);
  }

  checkIfSelected(value: string): boolean {
    return this.selectedItems?.some(x => x === value);
  }

  onChange(value: string, event: any): void {
    const isChecked = !!(event?.target?.checked ?? event?.srcElement?.checked);

    if (this.selectedItems.some(x => x === value)) {
      const index = this.selectedItems.findIndex(x => x === value);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      }
    } else {
      this.selectedItems.push(value);
    }

    if (isChecked && this.isNoneOfAbove(value)) {
      this.selectedItems = [];
      this.selectedItems.push(value);
    } else if (isChecked && !this.isNoneOfAbove(value)) {
      this.selectedItems = this.selectedItems.filter(x => !this.isNoneOfAbove(x));
    }

    this.submit();
  }

  submit(): void {
    if (this.selectedItems?.length && this.question) {
      this.question.answer = this.selectedItems.join('|');
      this.questionAnswer.emit(this.question);
    }
    else {
      this.question.answer = '';
      this.questionAnswer.emit(this.question);
    }
  }
}
